var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class TokenLoginSubscription {
    constructor(userInfo, requestGateway, tokenStorage, tokenValidator, legacyLogin) {
        this.onTokenLoginReceived = (sender, parameters) => __awaiter(this, void 0, void 0, function* () {
            try {
                const existingToken = this.tokenStorage.getToken();
                if (!existingToken || this.tokenValidator.isAnonymous(existingToken)) {
                    yield this.requestGateway.login(parameters);
                    this.legacyLogin(this.userInfo, parameters);
                }
            }
            catch (e) {
                this.userInfo.loginError(e);
            }
        });
        this.userInfo = userInfo;
        this.requestGateway = requestGateway;
        this.tokenStorage = tokenStorage;
        this.tokenValidator = tokenValidator;
        this.legacyLogin = legacyLogin;
    }
    subscribe() {
        this.userInfo.onTokenLoginReceived["TokenLoginSubscription"] = this.onTokenLoginReceived;
    }
}
//# sourceMappingURL=TokenLoginSubscription.js.map